export function InvoiceSelectionCtrl ($scope, $translate, $uibModalInstance, customer, invoices) {

  $scope.customer = customer;

  $scope.invoices = invoices || [];

  $scope.tableSettings = {
    columns: [
      {
        field : 'invoice_number',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.REFERENCE')
        }
      },
      {
        field : 'post_date',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.POST_DATE')
        },
        pipe    : 'globalDate',
        pipeArgs: 'mediumDate'
      },
      {
        classes: 'text-right',
        field  : 'total',
        header : {
          classes: 'text-right',
          text   : $translate.instant('JS_SPACE.COLUMNS.AMOUNT')
        },
        pipe: 'globalCurrency'
      },
      {
        classes: 'text-right',
        field  : 'balance_due',
        header : {
          classes: 'text-right',
          text   : $translate.instant('JS_SPACE.COLUMNS.BALANCE')
        },
        pipe: 'globalCurrency'
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_INVOICES_FOUND')
    },
    pagination: {
      enabled: false
    },
    rows: {
      highlight: {
        enabled: true
      },
      select: {
        enabled: true,
        multi  : true
      }
    },
    sorting: {
      enabled: false
    },
  };

  $scope.toggleAll = function () {
    $scope.allSelected = !$scope.allSelected;

    angular.forEach($scope.invoices, function (invoice) {
      invoice.selected = $scope.allSelected;
    });

    $scope.selectedItems = $scope.invoices.filter((row) => row.selected);
  };

  $scope.cancel = function () {
    $uibModalInstance.dismiss();
  };

  $scope.add = function () {
    $uibModalInstance.close($scope.selectedItems);
  };

  $scope.onRowClick = function ( event ) {
    $scope.selectedItems = $scope.invoices.filter(( invoice ) => invoice.selected);
  };
}